import "reflect-metadata";
import { lazy } from "react";
import { injectable, registry } from "tsyringe";
import { FeatureSetupDef, FeatureRootRoute, FeatureSetup } from "@app/types/feature.types";

 import { version, name } from "@feature/package.json";
import { FeatureToken } from "@app/constants/di";
import { featurePaths } from "@feature/constants/paths.constant";

const ARTransactionsListPage = lazy(() =>  import("@feature/pages/ARTransactionsList"));
const CreateARInvoicePage = lazy(() => import("@feature/pages/CreateARInvoice"));
const CreateArCreditnote = lazy(() => import("@feature/pages/ARCreditNote"));
const APTransactionsListPage = lazy(() => import("@feature/pages/APTransactionsList"));
const CreateAPInvoicePage = lazy(() => import("@feature/pages/CreateAPInvoice"));
const CreateAPCreditNote = lazy(() => import("@feature/pages/APCreditNote"));
const ArInvoiceExtractListPage = lazy(() => import("@feature/pages/ArInvoiceExtractList"));
const APARAccuralExtractListPage = lazy(() => import("@feature/pages/APARAccuralExtractList"));
const PLReportPage = lazy(() => import("@feature/pages/PLReport"));
const MdgListPage = lazy(() => import("@feature/pages/MdgList"));
const MdgViewPage = lazy(() => import("@feature/pages/MdgView"));
const SpecificationReportPage = lazy(() => import("@feature/pages/SpecificationReport"));
const ARApprovedsapdirectextractPage = lazy(() => import("@feature/pages/ARApprovedsapdirectextract"));
const InvoiceDocumentUploadPage = lazy(() => import("@feature/pages/InvoiceDocumentUpload"));

@injectable()
@registry([{ token: FeatureToken, useClass: ARTransactions }])
class ARTransactions implements FeatureSetupDef {
    GetFeatureSetup(): FeatureSetup {
        return {
            version,
            namespace: name,
            featuresRoot: this.features,
            permissions: [],
            index: true
        };
    }
    private readonly features: FeatureRootRoute = {
        requiredPermissions: [],
        children: [
            {
                title: "AR Transactions List",
                path: featurePaths.ARTransactionsList,
                page: ARTransactionsListPage
            },
            {
                title: "Create AR Invoice",
                path: featurePaths.CreateARInvoice,
                page: CreateARInvoicePage
            },
            {
                title: "Create AR Credit Note",
                path: featurePaths.ARCreditNote,
                page: CreateArCreditnote
            },
            {
                title: "AP Transactions List",
                path: featurePaths.APTransactionsList,
                page: APTransactionsListPage
            },
            {
                title: "Create AP Invoice",
                path: featurePaths.CreateAPInvoice,
                page: CreateAPInvoicePage
            },
            {
                title: "Create AP Credit Note",
                path: featurePaths.APCreditNote,
                page: CreateAPCreditNote
            },
            {
                title: "AR Invoice Extract List",
                path: featurePaths.ArInvoiceExtractList,
                page: ArInvoiceExtractListPage
            },
            {
                title: "AP AR Accrual Extract List",
                path: featurePaths.APARAccuralExtractList,
                page: APARAccuralExtractListPage
            },
            {
                title: "PL Report",
                path: featurePaths.PLReport,
                page: PLReportPage
            },
            {
                title: "Mdg List",
                path: featurePaths.MdgList,
                page: MdgListPage
            },
            {
                title: "MDG View",
                path: featurePaths.MdgView,
                page: MdgViewPage
            },
            {
                title: "Specification Report",
                path: featurePaths.SpecificationReport,
                page: SpecificationReportPage
            },
            {
                title: "AR Approved SAP Direct Extract",
                path: featurePaths.ARApprovedsapdirectextract,
                page: ARApprovedsapdirectextractPage
            },
            {
                title: "Invoice Document Upload",
                path: featurePaths.InvoiceDocumentUpload,
                page: InvoiceDocumentUploadPage
            }
        ]
    };
}
